import { render, staticRenderFns } from "./AllCampaigns.vue?vue&type=template&id=3877bbda&scoped=true&"
import script from "./AllCampaigns.vue?vue&type=script&lang=js&"
export * from "./AllCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./AllCampaigns.vue?vue&type=style&index=0&id=3877bbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3877bbda",
  null
  
)

export default component.exports